import { useMemo } from "react";
import { MinusCircleIcon, XCircleIcon } from "@heroicons/react/24/outline";
import { SERVICE_ORDER, SERVICE_COLORS } from "../constants";
import TimelineEvent from "./TimelineEvent";

export default function PipelineTimeline({ imageId, imageMeta }) {
  const pipeline = imageMeta?.pipeline || {};

  // Build combined timeline from all services
  const events = useMemo(() => {
    const all = [];

    SERVICE_ORDER.forEach((service) => {
      const svc = pipeline[service];
      if (!svc) return;

      // Add changelog events
      (svc.changelog || []).forEach((event) => {
        all.push({ ...event, service, type: "changelog" });
      });

      // Add diagnostics
      (svc.diagnostics || []).forEach((diag) => {
        all.push({ ...diag, service, type: "diagnostic", ts: diag.start_ts || diag.end_ts });
      });
    });

    // Sort by timestamp
    return all.sort((a, b) => new Date(a.ts || 0) - new Date(b.ts || 0));
  }, [pipeline]);

  if (!imageId) {
    return (
      <div className="timeline-empty">
        <div className="empty-icon">
          <MinusCircleIcon className="icon-lg" />
        </div>
        <div className="empty-text">Select an image to trace its journey through the Matrix</div>
      </div>
    );
  }

  if (events.length === 0) {
    return (
      <div className="timeline-empty">
        <div className="empty-icon">
          <XCircleIcon className="icon-lg" />
        </div>
        <div className="empty-text">No pipeline data available for this image</div>
      </div>
    );
  }

  return (
    <div className="pipeline-timeline">
      <div className="timeline-header">
        <div className="timeline-file-info">
          <span className="timeline-filename">{imageMeta?.filename || imageId}</span>
          <span className="timeline-id">{imageId}</span>
        </div>
        <div className="timeline-event-count">{events.length} events</div>
      </div>
      <div className="timeline-scroll">
        <div className="timeline-events">
          {events.map((event, idx) => (
            <TimelineEvent
              key={`${event.service}-${idx}`}
              event={event}
              color={SERVICE_COLORS[event.service] || "#89b8a5"}
              isLast={idx === events.length - 1}
            />
          ))}
        </div>
      </div>
    </div>
  );
}
